<template>
  <div ref="gantt" style="height:100%"></div>
</template>

<script>
import 'dhtmlx-gantt';
import './api.js';
import 'dhtmlx-gantt/codebase/ext/dhtmlxgantt_tooltip';

export default {
    name: 'gantt',
    data () {
        return {
        };
    },
    props: {
        tasks: {
            type: Object,
            default () {
                return {data: [], links: []};
            }
        }
    },
    mounted: function () {
        const that = this;
        gantt.config.task_height = 20;
        gantt.config.row_height = 40;

        // gantt.config.drag_project = true;// 允许拖拽
        gantt.config.show_task_cells = true;
        // 当task的长度改变时，自动调整图表坐标轴区间用于适配task的长度
        gantt.config.fit_tasks = true;
        var startDateEditor = {type: 'date', map_to: 'start_date'};
        var endDateEditor = {type: 'date', map_to: 'end_date'};
        // 列名设置
        gantt.config.columns = [
            {name: 'text', label: '任务名称', tree: true, width: '150'},
            {name: 'start_date',
                label: '开始日期',
                align: 'center',
                editor: startDateEditor,
                width: '80' },
            {name: 'end_date',
                label: '结束日期',
                align: 'center',
                editor: endDateEditor,
                width: '80' },
            {name: 'duration', label: '任务时长', align: 'center', width: '60' }
        ];
        gantt.config.scale_height = 3 * 28;// 设置表头高度
        gantt.config.work_time = false;
        gantt.config.autosize = 'xy';// 自适应甘特图的尺寸大小, 使得在不出现滚动条的情况下, 显示全部任务
        // gantt.config.drag_resize = true;//允许用户通过拖拽任务的条形图的两端来改变工期
        gantt.config.drag_move = true;// 允许用户拖动条形图来改变位置
        gantt.config.drag_progress = false;// 允许用户推拽条形图上用来调整进度百分比的小按钮
        gantt.config.date_scale = '%Y-%m-%d';// 日期格式化
        gantt.config.duration_unit = 'day';// 工期计算的基本单位
        gantt.config.duration_step = 1; // 工期计算的倍数
        gantt.config.readonly = true;
        // gantt.config.details_on_dblclick = false;// 关闭双击

        // 设置子坐标轴，将会在时间轴X的下面新增一行或多行坐标轴X（只不过单位粒度不一样），
        // 新增行数取  决于数组的长度，即数组每一项表示一行
        var weekScaleTemplate = function (date) {
            var dateToStr = gantt.date.date_to_str('%Y-%m-%d');
            var weekNum = gantt.date.date_to_str('(周 %W)');
            var endDate = gantt.date.add(gantt.date.add(date, 1, 'week'), -1, 'day');
            return dateToStr(date) + ' ~ ' + dateToStr(endDate);
        };
        gantt.config.subscales = [
            {unit: 'year', step: 1, format: '%Y年'},
            {unit: 'week', step: 1, template: weekScaleTemplate}
        ];

        // 单击绑定事件
        // var myEvent = gantt.attachEvent('onTaskClick', function (id, e) {
        //     console.log(id);
        //     that.$emit('nodeClick', id);
        // }, {id: 'my-click', once: false }); // 可以指定id，是否只执行一次
        // // 取消绑定的事件
        // gantt.detachEvent('my-click');
        // gantt.detachEvent(myEvent);
        gantt.attachEvent('onTaskClick', function (id, e) { // 任务双击事件
            that.$emit('nodeClick', id);
        });

        // gantt.attachEvent('onTaskDblClick', function (id, e) { // 任务双击事件
        //     // console.log("You've just clicked an item with id=" + id);
        //     console.log(id);
        //     that.$emit('nodeClick', id);
        // });

        // 突出周末
        gantt.templates.task_cell_class = function (item, date) {
            // debugger;
            if (date.getDay() == 0 || date.getDay() == 6) {
                return 'weekend';
            }
        };
        // 设置任务条进度内容
        gantt.templates.progress_text = function (start, end, task) {
            return "<div style='text-align:left;color:#fff;padding-left:20px'>" + Math.round(task.progress * 100) +
                    '% </div>';
        };

        // // 任务条显示内容
        // gantt.templates.task_text = function (start, end, task) {
        //     // return task.text + '(' + task.duration + '天)';
        //     return "<div style='text-align:center;color:#fff'>" + task.text + '(' + task.duration + '天)' +
        //             '</div>';
        // };

        gantt.templates.tooltip_text = function (start, end, task) {
            // console.log(task);
            var res = '';
            var start_date = new Date(task.start_date);
            var start_date_label = start_date.getFullYear() + '-' + (start_date.getMonth() + 1) + '-' + start_date.getDate();

            var end_date = new Date(task.end_date);
            var end_date_label = end_date.getFullYear() + '-' + (end_date.getMonth() + 1) + '-' + end_date.getDate();

            res += task.text + '</br>' + '开始时间:' + start_date_label + '</br>' + '结束时间:' + end_date_label + '</br>' + '任务进度:' + Number(task.progress) * 100 + '%' + '</br>' + '任务时长:' + task.duration + '工作日';
            return res;
        };

        gantt.init(this.$refs.gantt);
        gantt.parse(this.$props.tasks);
    },
    created () {
    },
    methods: {
        initData () {
            gantt.clearAll();// 清空数据
            gantt.parse(this.tasks);
        },
        exportToPDF () {
            gantt.exportToPDF();
        },
        exportToExcel () {
            gantt.exportToExcel(
                {
                    name: '进度甘特图.xlsx',
                    // columns: [
                    //     {name: 'text', label: '任务名称', tree: true, width: '150'},
                    //     {name: 'start_date', label: '开始日期', align: 'center', width: '80' },
                    //     {name: 'end_date', label: '结束日期', align: 'center', width: '80' },
                    //     {name: 'duration', label: '任务时长', align: 'center', width: '60' }
                    // ],
                    // server: 'https://myapp.com/myexport/gantt',
                    // data: this.tasks,
                    locale: 'cn',
                    // visual: true,
                    visual: 'base-colors',
                    raw: true,
                    cellColors: true,
                    skin: 'material'
                    // date_format: 'dddd d, mmmm yyyy'
                }
            );
        },
        exportToPNG () {
            gantt.exportToPNG({
                header: '<h1>进度甘特图</h1>',
                footer: '<h4> https://www.bcbpm.com/  北京鑫和怒创科技有限公司</h4>',
                name: '进度甘特图.png',
                locale: 'cn',
                // skin: 'terrace',
                skin: 'material',
                raw: true,
                visual: true
            });
        }
    }

};
</script>

<style>
    @import "~dhtmlx-gantt/codebase/dhtmlxgantt.css";
    @import "~dhtmlx-gantt/codebase/skins/dhtmlxgantt_skyblue.css";

    .gantt_task_line, .gantt_line_wrapper {
        margin-top: -9px;
    }
    .gantt_side_content {
        margin-bottom: 7px;
    }
    .gantt_task_link .gantt_link_arrow {
        margin-top: -12px
    }
    .gantt_side_content.gantt_right {
        bottom: 0;
    }

    .baseline {
        position: absolute;
        border-radius: 2px;
        opacity: 0.6;
        margin-top: -7px;
        height: 12px;
        background: #ffd180;
        border: 1px solid rgb(255,153,0);
    }

    .weekend {
        background: #f4f7f4;
    }
    .gantt_selected .weekend{
        background:#f7eb91;
    }

    .gantt_task_scale .gantt_scale_cell {
        border-right: 1px solid #a4bed4 !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/Gantt/Gantt.vue